<template>
  <a-select
    v-model:value="innerValue"
    mode="multiple"
    :style="{ width: '100%' }"
    :max-tag-count="3"
    placeholder="Статус: все"
    @change="handleChange">
    <a-select-option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label">
      {{ option.label }}
      <span
        v-if="counts"
        :style="{ color: 'rgba(0, 0, 0, 0.45)' }">
        {{ counts[option.value] ?? 0 }}
      </span>
    </a-select-option>
  </a-select>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { statusOptions } from '@/helpers/entityStatus';

const props = defineProps({
  // Пустой массив означает «все состояния» — это значение по умолчанию.
  modelValue: {
    type: Array,
    default: () => [],
  },
  // Сколько записей в каждом состоянии: пустое состояние видно как ноль,
  // в отличие от пустой вкладки, которая выглядит как поломка.
  counts: {
    type: Object,
    default: null,
  },
  // Какие состояния вообще бывают у справочника: у SVG-фурнитуры,
  // апертур и молдингов «устаревших» не бывает.
  statuses: {
    type: Array,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const options = computed(() => (props.statuses
  ? statusOptions().filter(({ value }) => props.statuses.includes(value))
  : statusOptions()));
const innerValue = ref([...props.modelValue]);

watch(() => props.modelValue, (value) => {
  innerValue.value = [...value];
});

const handleChange = (value) => emit('update:modelValue', value);
</script>
